<template>
  <div class="gift-details app-container">
    <div class="global-header-wrap">
      <h3>
        {{this.$route.query.title}}
      </h3>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="addCode">
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button>
      </div>
    </div>

    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div class="global-body-wrap">
        <appTable
          :tableData="tableData"
          :tableProps="tableProps"
          :currentPage="params.page"
          :pageSize="params.limit"
          :expand="true"
          @tableHandle="tableHandle"
        />
      </div>
      <pagination :pageSize="params.limit" :current-page="params.page" :total="total" @pageNum="pageNum" />
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import listSearch from "@/components/listSearch";
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
export default {
  components: {
    listSearch,
    appTable,
    pagination
  },
  mixins: [listMixin],
  computed: {
    ...mapGetters(["appendPopup", "userInfo"]),
    tableProps() {
      let tableProps = [
        {
          prop: "title",
          label: "标题"
        },
        {
          prop: "author",
          label: "作者"
        },
        {
          width: 200,
          prop: "poetryDetailsHandle",
          label: this.$t("org.manage")
        }
      ];
      return tableProps;
    }
  },
  data() {
    return {
      gift: {
        code: "",
        phone: "",
        password: "",
        verifyCode: ""
      },
      cardTitle: '',
      params: {
        limit: 20,
        page: localStorage.getItem('page')?parseInt(localStorage.getItem('page')):1,
        type: this.$route.query.type
      },
      codes: [],
      codesFlag: false,
      tableData: [],
      total: 0,
      title: "",
      giftCodeItem: null,
      rules: {
      }
    };
  },

  created() {
  },

  methods: {
    toggleCode () {
      this.codesFlag = !this.codesFlag
      if (this.codesFlag) {
        this.codes = [
          {
            id: String(Math.random()).substring(2, 12),
            code: '',
            password: '',
            verifyCode: ''
          }
        ]
      } else {
        this.codes = []
      }
    },
    addParam () {
      const obj = {
        id: String(Math.random()).substring(2, 12),
        code: '',
        password: '',
        verifyCode: ''
      }
      this.codes.push(obj)
    },

    deleteParam (arr, id) {
      arr.map((item, i) => {
        if (item.id === id) {
          arr.splice(i, 1)
        }
      })
    },

    getList() {
      if (localStorage.getItem('page')) {
        this.params.page = parseInt(localStorage.getItem('page'))
      }
      this.$http.getPoetryDetails(this.params).then(res => {
        this.tableData = res.data.results;
        this.total = res.data.count;
      });
    },

    addCode() {
      this.$router.push({ name: "createPoetryDetail", query: { type: this.$route.query.type }});
    },

    codeEvn(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.title === "新增") {
            this.create();
          } else {
            this.editCode();
          }
        } else {
          return false;
        }
      });
    },

    edit(data) {
      this.$router.push({ name: "createPoetryDetail", query: { id: data.row._id } });
    },

    create() {
      this.$http.addCard(form).then(res => {
        this.getList();
      });
    },

    editCode() {
      let params = {};
      params.phone = this.gift.phone;
      params.password = this.gift.password;
      params.verifyCode = this.gift.verifyCode;

      if (this.userInfo.roleValue === 1) {
        params.code = this.gift.code;
        if (params.code.trim() === '') {
          this.elMsg(this.$t("sale.card.inputCode"), "warning");
          return
        }
      } else {
        delete params.code;
      }

      this.$http
        .updateGiftCode(this.giftCodeItem._id, params)
        .then(res => {
          this.elMsg(this.$t("alertMsg.editSuccess"), "success");
          this.getList();
        })
        .catch(err => {
          this.elMsg(err.response.data.message, "error");
        });
    },

    toDetails(data) {
      this.giftCodeItem = data.row;
    },

    del(data) {
      this.$http.delPoetryItem({_id: data.row._id}).then(res => {
          this.elMsg(this.$t("alertMsg.delSuccess"), "success");
          this.getList();
        }).catch(err => {
          this.elMsg(err.response.data.message, "error");
        });
    },
    pageNum(page) {
      this.params.page = page;
      localStorage.setItem('page', page);
      this.getList();
    },

    closeDialog() {
      this.codeFile = null
      this.codes = []
      this.codesFlag = false
      for (let i in this.gift) {
        this.gift[i] = "";
      }
    }
  },
  mounted() {},
  beforeDestroy() {
    // localStorage.removeItem('page')
  }
};
</script>

<style lang="scss" scoped>
.gift-details-header {
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    // margin-right:10px;
  }
}
.gift-details-pagination {
  padding: 10px;
  text-align: right;
}
.gift-import-btn {
  margin-top: 10px;
}
.gift-mgt-fileName {
  margin-right: 10px;
}
.hand-add-btn {
  background-color: #56a3fd;
  border-radius: 3px;
  padding: 0px 12px;
  margin-left: 10px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 12px;
  &:hover {
    background-color: #5bbbff;
  }
}
</style>
